import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../services/api';
import { isManagerOnly } from '../Manager/managerRole';
import { clearRoles, hasStoredRole, persistRoles, syncFingerprintFromCookie } from '../services/clientAuth';

const LOGIN_URL =
    process.env.REACT_APP_ID_LOGIN_URL ||
    `${(process.env.REACT_APP_ID_WEB_URL || '').replace(/\/$/, '') || ''}/login`;

function redirectToLogin() {
    try {
        const returnTo = encodeURIComponent(window.location.href);
        window.location.replace(`${LOGIN_URL}?returnTo=${returnTo}`);
    } catch {
        window.location.replace(LOGIN_URL);
    }
}

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [verifiedRoles,setVerifiedRoles]=useState([]);

    useEffect(() => {
        const verifyAuth = async () => {
            try {
                const response = await api.get('/api/check');
                syncFingerprintFromCookie();
                persistRoles(response?.data?.roles);
                setVerifiedRoles(Array.isArray(response?.data?.roles)?response.data.roles:[]);
                setIsAuthenticated(true);
            } catch (error) {
                const status = error?.response?.status;
                clearRoles();
                if (!status || status === 401) {
                    redirectToLogin();
                    return;
                }
                setIsAuthenticated(false);
            } finally {
                setIsLoading(false);
            }
        };

        verifyAuth();
    }, []);

    if (isLoading) return <div>Загрузка...</div>;
    if (!isAuthenticated) return <div>Нет доступа</div>;
    if (isManagerOnly(verifiedRoles) && !location.pathname.startsWith('/manager/')) {
        const ticket=location.pathname.match(/^\/(?:task|v2\/tickets)\/(\d+)$/);
        return <Navigate to={ticket?'/manager/tickets/'+ticket[1]:location.pathname.startsWith('/chats')?'/manager/chats':location.pathname==='/profile'?'/manager/profile':'/manager/tickets'} replace/>;
    }
    if (allowedRoles.length > 0 && !hasStoredRole(allowedRoles)) {
        return <Navigate to="/board" replace />;
    }

    return children;
};

export default ProtectedRoute;
